/* Define all error messages here */

export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export const INTERNAL_SERVER_ERROR_MESSAGE =
  'There was an error processing your request, please try again later';
